import api from "../http/api";

/**
 * Consulta o status atual do plano contratado pela mantenedora da instituição.
 * Retorna o objeto PlanLimitInfo (current/limit/next/mantenedora) quando disponível.
 *
 * Em caso de falha (rede/5xx/sem permissão) retorna null para não derrubar a UI —
 * o banner simplesmente não é exibido nessa situação.
 */
export const getPlanStatus = async (institutionId) => {
  if (!institutionId) return null;

  try {
    const response = await api.client.get(
      `api/v1/Institutions/${encodeURIComponent(institutionId)}/plan-status`
    );

    const data = response?.data;
    if (!data || data.available === false) return null;

    return data;
  } catch (error) {
    console.warn(
      `Falha ao consultar plan-status (institutionId=${institutionId}):`,
      error?.message
    );
    return null;
  }
};
